import { connect } from 'react-redux'
import FormSearchView from './FormSearch.component'
import {
  setAmbients, setBaths, setAreaMin, setAreaMax, setPriceMin, setPriceMax, changeCurrency,
  setGarages, setRooms, setCategory, setTerrain, setAreaMinLow, setAreaMaxLow, setNaves
} from '../../../../../actions/searchBar'

const mapStateToProps = (state) => {
  return {
    min_price: state.searchBar.price_min,
    max_price: state.searchBar.price_max,
    min_area: state.searchBar.area_min,
    max_area: state.searchBar.area_max,
    min_area_low: state.searchBar.area_low_min,
    max_area_low: state.searchBar.area_low_max,
    ambients: state.searchBar.ambients,
    bathrooms: state.searchBar.bathrooms,
    bedrooms: state.searchBar.bedrooms,
    garages: state.searchBar.garages,
    naves: state.searchBar.naves,
    terrain: state.searchBar.terrain,
    category: state.searchBar.category,
    currency: state.searchBar.currency,
    originPath: state.searchBar.originPath.name,
    originOffice: state.searchBar.originOffice.name,
    terrains: state.terrains.uses
  }
}

const mapDispatchToProps = (dispatch) => {

  return {
    onSelectAmbients: value => dispatch(setAmbients(value)),
    onSelectBaths: value => dispatch(setBaths(value)),
    onChangeAreaMin: event => dispatch(setAreaMin(event.target.value)),
    onChangeAreaMax: event => dispatch(setAreaMax(event.target.value)),
    onChangePriceMin: event => dispatch(setPriceMin(event.target.value)),
    onChangePriceMax: event => dispatch(setPriceMax(event.target.value)),
    changeCurrency: (value) => dispatch(changeCurrency(value)),
    onSelectGarages: (value) => dispatch(setGarages(value)),
    onSelectRooms: (value) => dispatch(setRooms(value)),
    onSelectNaves: (value) => dispatch(setNaves(value)),
    onSelectCategory: (value) => dispatch(setCategory(value)),
    onSelectTerrain: (value) => dispatch(setTerrain(value)),
    onChangeAreaMinLow: event => dispatch(setAreaMinLow(event.target.value)),
    onChangeAreaMaxLow: event => dispatch(setAreaMaxLow(event.target.value)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormSearchView)



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/FormSearch/FormSearch.container.js